import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { EKeyCode } from '@/enums/e_key_code';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import { WATCHER_SHORTCUT__base } from '@/pages/_base/shortcuts/_watchers/WATCHER_SHORTCUT__base';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { timestamp_ms } from '@shared/utils/utils_time';
import { useRef } from 'react';
import { HOOK_USER_TASK__create } from '../_hooks/HOOK_USER_TASK__create';

export function WATCHER_SHORTCUT__user_task_create() {
  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);

  const { create_user_task, is_loading } = HOOK_USER_TASK__create();

  const ref_last_created_at = useRef(NaN);

  /*
   * EVENTS
   */
  function on_shortcut_pressed() {
    if (is_loading) return false;
    if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_USER_TASK_CREATE)) return false;

    let timenow = timestamp_ms();
    if (!isNaN(ref_last_created_at.current) && timenow - ref_last_created_at.current <= CONSTANTS_TIME__client.THROTTLE_USER_TASK_CREATE) return false;

    ref_last_created_at.current = timenow;

    void create_user_task(true);

    return true;
  }

  /*
   * HTML
   */

  if (is_loading) return null;
  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_USER_TASK_CREATE)) return null;

  return <WATCHER_SHORTCUT__base key_codes={[EKeyCode.C]} {...{ on_shortcut_pressed }} />;
}
